import Papa from "papaparse";

const downloadCsv = (object, filename) => {
  let csv = Papa.unparse(object, { delimiter: ";" });

  let csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  let csvUrl = navigator.msSaveBlob
    ? navigator.msSaveBlob(csvData, filename)
    : window.URL.createObjectURL(csvData);
  let tempLink = document.createElement("a");
  tempLink.href = csvUrl;
  tempLink.setAttribute("download", filename);
  tempLink.click();
};

export default downloadCsv;



// WEBPACK FOOTER //
// src/services/downloadCsv.js